import styled from 'styled-components';

import { fontFamilySecondary } from 'styles';

const Wrapper = styled.h2`
  align-items: center;
  display: flex;
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;
  padding: 0;
  width: 100%;
`;

export default Wrapper;
